/**
 * Счётчики статусов подписки: GET /admin/clients/status-counts.
 * Кормят дропдаун фильтра «Статус» — числа напротив каждого статуса.
 * Мок-режим считает по MOCK_CLIENTS, как раньше делал refs.ts.
 */

import {apiEnabled, http} from '@services/utils';

import {MOCK_CLIENTS} from '../mocks';
import type {SubscriptionStatus} from '../types';

export type StatusCounts = Record<SubscriptionStatus, number>;

const asCount = (v: unknown): number => (typeof v === 'number' ? v : 0);

export const getStatusCounts = async (): Promise<StatusCounts> => {
  if (!apiEnabled) {
    const count = (s: SubscriptionStatus): number =>
      MOCK_CLIENTS.filter((c) => c.subscriptionStatus === s).length;
    return {
      trial: count('trial'),
      trial_expired: count('trial_expired'),
      awaiting_card: count('awaiting_card'),
      active: count('active'),
      past_due: count('past_due'),
      blocked: count('blocked'),
      cancelled: count('cancelled'),
    };
  }

  // Гейтвей отдаёт camelCase-ключи — раскладываем в snake-статусы домена
  const raw = await http<Record<string, unknown>>('admin/clients/status-counts', {
    skipCaseConversion: true,
  });
  return {
    trial: asCount(raw.trial),
    // Бэк пока не считает истёкший триал отдельно (нет в status-counts) — 0
    trial_expired: asCount(raw.trialExpired),
    awaiting_card: asCount(raw.awaitingCard),
    active: asCount(raw.active),
    past_due: asCount(raw.pastDue),
    blocked: asCount(raw.blocked),
    cancelled: asCount(raw.cancelled),
  };
};
